import { useDroppable } from '@dnd-kit/core';
import { FNodeTypesEnum } from '@spazious/dollhouse-fsetup';
import { styled } from '@spazious/dollhouse-theme';
import { Flex, FlexProps } from '@spazious/dollhouse-uikit';

import { CanvasTracker } from '../../components/CanvasTracker/index.js';

export interface MainLayoutProps {
  children?: React.ReactNode;
  aside?: React.ReactNode;
  backdrop?: React.ReactNode;
  asidePosition?: 'top' | 'right' | 'bottom' | 'left';
}

export const Aside = styled(Flex)`
  position: relative;
  z-index: 10;
`;

export const Content = styled(Flex)`
  position: relative;
  flex: 1;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
`;

export const Container = styled(Flex)`
  height: 100%;
`;

const asidePositionMapping: Record<
  NonNullable<MainLayoutProps['asidePosition']>,
  FlexProps['flexDirection']
> = {
  top: 'column',
  right: 'row-reverse',
  bottom: 'column-reverse',
  left: 'row',
};

export const MainLayout = styled(
  ({ children, aside, backdrop, asidePosition = 'left', ...restProps }: MainLayoutProps) => {
    const { setNodeRef } = useDroppable({
      id: 'droppable',
      data: {
        accepts: Object.values(FNodeTypesEnum),
      },
    });

    return (
      <Flex {...restProps}>
        {backdrop && <CanvasTracker ref={setNodeRef}>{backdrop}</CanvasTracker>}
        <Container flexDirection={asidePositionMapping[asidePosition]} width="100%">
          <Aside>{aside}</Aside>
          <Content>{children}</Content>
        </Container>
      </Flex>
    );
  }
).withConfig({
  displayName: 'MainLayout',
})`
  position: relative;
  width: 100dvw;
  height: 100dvh;
  background-color: var(--spz-sys-color-surface);
`;
